import { memo } from 'react';
import { generateUserAgentValues, NAVER_APP_DOWNLOAD_LINK } from '@financial/app-js-interfaces';
import { ERROR_CODE } from './constant.mjs';
import { MssModal } from './MssModal.mjs';
import { useMSSValidator } from './useMSSValidator.mjs';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

const MssChecker = /*#__PURE__*/memo(_ref => {
  let {
    children,
    ...props
  } = _ref;
  const {
    activeRemoteAppNames,
    deviceCode
  } = useMSSValidator(props);
  if (deviceCode && deviceCode === ERROR_CODE.알수없음) {
    const {
      isAndroid,
      isNaverOM,
      isIOS
    } = generateUserAgentValues(window.navigator.userAgent);
    if (isAndroid && isNaverOM) {
      return /*#__PURE__*/jsx(MssModal, {
        description: "\uD398\uC774\uC9C0\uB97C \uC774\uB3D9\uD558\uC5EC \uC9C4\uD589\uD569\uB2C8\uB2E4.",
        onButtonClick: () => {
          window.location.href = `naversearchapp://inappbrowser?version=30&url=${encodeURIComponent(window.location.href)}`;
        }
      });
    }
    return /*#__PURE__*/jsx(MssModal, {
      description: "\uCD5C\uC2E0 \uB124\uC774\uBC84\uC571\uC744 \uC124\uCE58 \uD6C4 \uC774\uC6A9 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
      onButtonClick: () => {
        if (isAndroid) {
          window.location.href = NAVER_APP_DOWNLOAD_LINK.ANDROID;
        } else if (isIOS) {
          window.location.href = NAVER_APP_DOWNLOAD_LINK.IOS;
        }
      }
    });
  }
  if (deviceCode && deviceCode !== ERROR_CODE.성공) {
    return /*#__PURE__*/jsx(MssModal, {
      description: `[code: ${deviceCode}] 유효하지 않은 네이버앱 환경입니다.`,
      onButtonClick: () => {
        window.location.href = 'naverapp://closewindow';
      }
    });
  }
  if (activeRemoteAppNames && activeRemoteAppNames.length > 0) {
    return /*#__PURE__*/jsx(MssModal, {
      title: /*#__PURE__*/jsxs(Fragment, {
        children: ["\uB0B4 \uC2A4\uB9C8\uD2B8\uD3F0\uC5D0 \uC2E4\uD589\uC911\uC778", /*#__PURE__*/jsx("br", {}), "\uC6D0\uACA9\uC81C\uC5B4 \uC571\uC774 \uAC10\uC9C0\uB418\uC5C8\uC2B5\uB2C8\uB2E4."]
      }),
      description: /*#__PURE__*/jsxs(Fragment, {
        children: ["\uAE08\uC735 \uC815\uBCF4 \uC720\uCD9C\uC5D0 \uB530\uB978 \uD53C\uD574\uAC00", /*#__PURE__*/jsx("br", {}), "\uBC1C\uC0DD\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.", /*#__PURE__*/jsx("br", {}), "\uC544\uB798 \uC571\uC744 \uC885\uB8CC\uD55C \uD6C4 \uC774\uC6A9\uD574 \uC8FC\uC138\uC694.", /*#__PURE__*/jsx("br", {}), /*#__PURE__*/jsx("br", {}), "\uAC10\uC9C0\uB41C \uC571: ", activeRemoteAppNames.join(', ')]
      }),
      onButtonClick: () => {
        window.location.href = 'naverapp://closewindow';
      }
    });
  }
  return /*#__PURE__*/jsx(Fragment, {
    children: children
  });
});

export { MssChecker };
